// Only used to parse relative paths; a callback that resolves elsewhere is not an employee-setup callback.
const RELATIVE_BASE = 'https://relative.invalid'

export function passwordSetupCallback(pathname: string, invitationId: string, employeeEmail: string): string {
  const params = new URLSearchParams({ invitation_id: invitationId, employee_email: employeeEmail, password_set: '1' })
  return encodeURIComponent(`${pathname}?${params.toString()}`)
}

/**
 * Parses a reset-password callback built by passwordSetupCallback.
 * Returns undefined unless it is a relative /:regionCode/employee-setup path with password_set=1.
 * Does not read window, so it is safe during server-side rendering.
 */
export function parsePasswordSetupCallback(callbackPath?: string): { invitationId?: string } | undefined {
  if (!callbackPath) return undefined
  try {
    const url = new URL(callbackPath, RELATIVE_BASE)
    if (url.origin !== RELATIVE_BASE || !/^\/[a-z]{2}\/employee-setup$/.test(url.pathname) || url.searchParams.get('password_set') !== '1') {
      return undefined
    }
    return { invitationId: url.searchParams.get('invitation_id') ?? undefined }
  } catch {
    return undefined
  }
}

export function isPasswordSetupCallback(callbackPath?: string): boolean {
  return !!parsePasswordSetupCallback(callbackPath)
}
